<template>
  <div class="BoardTable">
    <!-- TODO: fix :hasResults="hasResults" not showing tabs -->
    <TableHead :hasResults="true" :pagination="pagination" />
    <div class="results" :class="{ isTable: !!pagination.dataColumns.length }">
      <slot />
    </div>
    <Loader v-if="isFetching" class="lg info" />
    <slot v-else-if="!hasResults" name="noResults">
      <Empty>
        {{ $t('empty') }}
      </Empty>
    </slot>
  </div>
</template>

<script>
import PaginationAccess from '@mixins/PaginationAccess'
import TableHead from './TableHead'

export default {
  mixins: [PaginationAccess],
  components: { TableHead },
  props: {
    hasResults: Boolean,
    isFetching: Boolean,
  },
}
</script>

<style lang="scss">
.BoardTable {
  > .results {
    border-top: 1px solid $border-color;
    padding: $grid-unit;
  }
}
</style>

<i18n>
{
  "en": {
    "empty": "No results."
  }
}
</i18n>
